import { Injectable } from '@angular/core';
import * as braze from '@braze/web-sdk'
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrazeService {
  private contentCardsSubject: Subject<braze.ContentCards> = new Subject();
  contentCards$ = this.contentCardsSubject.asObservable();

  constructor() { }

  getContentCards() {
    return this.contentCards$;
  }

  setContentCards(cards: braze.ContentCards) {
    this.contentCardsSubject.next(cards);
  }
}
